import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import styled from 'styled-components';

interface IWarningMessage {
  message: string;
  iconFillColor?: string;
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
`;

const IconContainer = styled.div`
  display: flex;
  margin: 0 4px 0 0;
`;

const Message = styled.p`
  margin: 0;
  font-size: 0.8rem;
  font-style: normal;
  text-align: start;
  line-height: 1.125rem;
  font-weight: ${Styles.fontWeight.normal};
`;

const WarningMessage: React.FC<IWarningMessage> = ({ message }) => (
  <Container>
    <IconContainer data-testid="error-icon">
      <Icon icon="error" color="icon-default" width="16px" aria-hidden />
    </IconContainer>
    <Message>{message}</Message>
  </Container>
);

export default WarningMessage;
